import * as Sentry from "@sentry/browser";
import Modal from "./modules/frontv2/Modal";
import MobileSearch from "./modules/frontv2/MobileSearch";
import MobileMenu from "./modules/frontv2/MobileMenu";
import Faq from "./modules/frontv2/Faq";
import { initDrops } from "./modules/common/drop";
import { initScroll } from "./modules/scrolling";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { initSelects } from "./modules/common/selects";
import { initFormValidation } from "./modules/common/form-validation";
import { initCommon } from "./modules/common/common";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";

document.addEventListener('DOMContentLoaded', () => {
  // Init Sentry JS
  if(document.body.dataset.env === 'prod') {
    Sentry.init({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  }

  //common stuff
  initCommon();

  //Dropdowns and dropups
  initDrops();

  //Modal popups
  Modal.bindAllModals();

  //Header bar scroll logic
  initScroll();

  //Mobile menu
  initMobileMenu();

  initSelects();

  new MobileSearch();
  new MobileMenu();

  //Init form validation + recaptcha
  initFormValidation();

  //Analytics
  initGoogleEcommerce();

  //all faq logic
  new Faq();

  //Search bar logic algolia
  initAutocomplete();
});
